"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.stringify = stringify;
/**
 * Parses a legacy phone number string into expected value object
 *
 * @param {String} str - A legacy phone number format: +CALLINGCODE.LINENUMBER
 * @returns {Object} A parsed phone number { callingCode, lineNumber }
 */
function parse(str) {
  const [first, ...second] = str.replace('+', '').split('.');
  return {
    // If we get two parts, the first is the callingCode. Otherwise, there is no callingCode
    callingCode: second.length ? first : '',
    // If we get two parts, the second is the lineNumber. Otherwise, the first is the lineNumber
    lineNumber: second.length ? second.join('.') : first
  };
}

/**
 * Stringifies a value object to a legacy format
 *
 * @param {Object} value - Expected value object
 * @param {String} value.callingCode - The international calling code, defined by the dropdown
 * @param {String} value.lineNumber - The line number, defined by the text input
 * @returns {String} - A legacy phone number format: +CALLINGCODE.LINENUMBER
 */
function stringify(_ref) {
  let {
    callingCode,
    lineNumber
  } = _ref;
  return [Boolean(callingCode) && `+${callingCode}`, lineNumber].filter(Boolean).join('.');
}